<template>
  <footer class="bg-[#0f0f0f] text-white">
    <!-- 메인 영역 -->
    <div class="max-w-6xl mx-auto px-4 lg:px-6 pt-14 pb-10">
      <!-- 고객센터 (상단 강조) -->
      <div class="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-10">
        <div>
          <p class="text-[12px] font-medium text-white/40 uppercase tracking-widest mb-3">Customer Service</p>
          <a href="tel:1533-9012" class="group flex items-center gap-4">
            <span class="text-[42px] lg:text-[52px] font-black tracking-tight text-white group-hover:text-blue-400 transition-colors">
              1533-9012
            </span>
            <span class="hidden lg:flex items-center justify-center w-12 h-12 rounded-full bg-white/10 group-hover:bg-blue-500 transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
            </span>
          </a>
          <div class="mt-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-[13px] text-white/50">
            <span>평일 09:00 - 18:00</span>
            <span class="hidden sm:block w-1 h-1 rounded-full bg-white/30"></span>
            <span>주말/공휴일 휴무</span>
          </div>
        </div>

        <!-- 이메일 + SNS -->
        <div class="flex flex-col items-start lg:items-end gap-3 w-[208px]">
          <!-- 이메일 -->
          <a
            href="mailto:eslabsofficial@gmail.com"
            class="group w-full flex items-center justify-center gap-3 py-3 rounded-xl bg-white/5 hover:bg-white/10 transition-colors"
          >
            <svg class="w-5 h-5 text-white/40 group-hover:text-white transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
            <span class="text-[13px] text-white/70 group-hover:text-white transition-colors">eslabsofficial@gmail.com</span>
          </a>

          <!-- 소셜 링크 -->
          <div class="w-full grid grid-cols-4 gap-4">
            <a href="https://instagram.com" target="_blank" class="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 hover:bg-white/10 transition-colors">
              <svg class="w-5 h-5 text-white/40 hover:text-white transition-colors" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="https://youtube.com" target="_blank" class="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 hover:bg-white/10 transition-colors">
              <svg class="w-5 h-5 text-white/40 hover:text-white transition-colors" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
            <a href="https://blog.naver.com" target="_blank" class="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 hover:bg-white/10 transition-colors">
              <span class="text-[13px] font-bold text-white/40 hover:text-white transition-colors">N</span>
            </a>
            <a href="https://pf.kakao.com" target="_blank" class="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 hover:bg-white/10 transition-colors">
              <svg class="w-5 h-5 text-white/40 hover:text-white transition-colors" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 3c-5.523 0-10 3.582-10 8 0 2.846 1.882 5.347 4.727 6.764l-.917 3.236 3.707-2.421c.813.12 1.655.183 2.483.183 5.523 0 10-3.582 10-8s-4.477-8-10-8z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <!-- 구분선 -->
      <div class="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-10"></div>

      <!-- 회사 정보 -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
        <!-- 좌측: 로고 + 정보 -->
        <div>
          <div class="mb-5">
            <span class="text-[10px] font-bold text-blue-400 uppercase tracking-widest">BETA</span>
            <div class="mt-1">
              <span class="text-[22px] font-black">물어다줄개</span>
            </div>
          </div>

          <div class="space-y-2 text-[13px] text-white/40 leading-relaxed">
            <p>
              <span class="text-white/60">대표</span> 심응선
              <span class="mx-2 text-white/20">|</span>
              <span class="text-white/60">사업자등록번호</span> 227-31-01670
            </p>
            <p>
              <span class="text-white/60">통신판매업</span> 제 2024-충북청주-2550
            </p>
            <p class="text-white/30">
              충청북도 청주시 서원구 충대로1, S1-3동 2층 201호<br class="sm:hidden" />
              <span class="hidden sm:inline"> </span>충북대학교 충북Pro메이커센터
            </p>
          </div>
        </div>

        <!-- 우측: 링크 -->
        <div class="lg:text-right flex flex-col justify-end">
          <div class="flex flex-wrap lg:justify-end gap-4">
            <router-link to="/terms" class="text-[13px] text-white/50 hover:text-white transition-colors">
              이용약관
            </router-link>
            <router-link to="/privacy" class="text-[13px] text-white/50 hover:text-white transition-colors font-medium">
              개인정보처리방침
            </router-link>
            <router-link to="/mypage/support" class="text-[13px] text-white/50 hover:text-white transition-colors">
              고객센터
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 하단 카피라이트 -->
    <div class="border-t border-white/5">
      <div class="max-w-6xl mx-auto px-4 lg:px-6 py-5">
        <p class="text-[12px] text-white/25 text-center lg:text-left">
          © {{ currentYear }} ESLabs Corporation. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'AppFooter',
  setup() {
    const currentYear = computed(() => new Date().getFullYear())

    return {
      currentYear
    }
  }
}
</script>
